<template>
  <div>
    <LeftSidebarMarkets
      :newVisibleLeft="userInteractions.newVisibleLeft"
      :hoverVariable="userInteractions.hoverVariable"
      :hoverVariableSubItem="userInteractions.hoverVariableSubItem"
      :newSelectedAnalysis="userSelections.newSelectedAnalysis"
      :newSelectedAnalysisParent="userSelections.newSelectedAnalysisParent"
      :itemsInformation="sidebarData.items"
      @onHoverLeftSidebar="onHoverLeftSidebar"
      @onHoverLeftSidebarSubItem="onHoverLeftSidebarSubItem"
      @onLeftSidebarAnalysis="onLeftSidebarAnalysis"
      @eventOnUserClick="onUserClickLeftSidebarShow"
      @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
      @onUserChangeAnalysis="onUserChangeAnalysis"
      @onUserCurrencySelection="onUserCurrencySelection"
    />
  </div>
</template>

<script>
import LeftSidebarMarkets from "../../sideBars/LeftSidebarMarkets.vue";
import { format } from "d3";

export default {
  name: "LeftSidebarCurrencies",
  components: {
    LeftSidebarMarkets
  },
  props: {
    selectedAnalysis: { required: true, default: "" },
    selectedAnalysisParent: { required: true, default: "" },
    visibleLeft: { required: true, type: Boolean, default: false },
    listAnalysis: { required: true, type: Object, default: () => {} },
    currencySpecs: { required: true, type: Array, default: () => [] },
    currencyInformation: { required: true, default: {} },
    activeElements: { required: true, default: {} },
    showLoading: { required: false, default: true },
    spot: { required: false, default: 0 },
    updatedDate: { required: false, default: "" }
  },
  data() {
    return {
      userInteractions: {
        hoverVariable: "",
        hoverVariableSubItem: "",
        newVisibleLeft: false
      },
      sidebarData: {
        items: [
          {
            text: "",
            nameEvent: "",
            bdr: false,
            itemHeader: false,
            classNameIcon: "",
            bdrTransition: false
          }
        ]
      },
      userSelections: {
        newSelectedAnalysis: "",
        newSelectedAnalysisParent: ""
      }
    };
  },
  created() {
    this.setItemsSideBar();
  },
  mounted() {
    this.userSelections.newSelectedAnalysis = this.selectedAnalysis;
    this.userSelections.newSelectedAnalysisParent = this.selectedAnalysisParent;
    Object.assign(this["userInteractions"], {
      newVisibleLeft: this.visibleLeft
    });
  },
  watch: {
    activeElements: {
      handler(newVal) {
        for (const item of this.sidebarData.items) {
          switch (item.nameData) {
            case "currency_name":
              item.childSelected = newVal.currency;
              break;
            case "name":
              item.childSelected = `${newVal.analysis
                .slice(0, 1)
                .toUpperCase()}${newVal.analysis.slice(1).toLowerCase()}`;
              break;
          }
        }
      },
      deep: true
    },
    selectedAnalysis(val) {
      this.userSelections.newSelectedAnalysis = val;
    },
    selectedAnalysisParent(val) {
      this.userSelections.newSelectedAnalysisParent = val;
    },
    visibleLeft(val) {
      Object.assign(this["userInteractions"], {
        newVisibleLeft: val
      });
    },
    "sidebarData.items": {
      handler() {},
      deep: true
    },
    listAnalysis() {
      this.setItemsSideBar();
    },
    currencySpecs: {
      handler() {},
      deep: true
    },
    currencyInformation() {
      this.dataInfo;
      this.setItemsSideBar();
    },
    showLoading() {
      this.setDisabledElement("Currencies", "showLoading");
    },
    spot() {
      this.setNewSpot();
    },
    dataInfo() {}
  },
  computed: {
    dataInfo() {
      const currInfo = this.currencyInformation;
      return `
      <table style='border-spacing: 5px !important; border-collapse: separate;' class="table--dataInfo">
        <thead>
          <tr>
            <th colspan='2' style='text-align: center; vertical-align: middle;'><strong>${
              currInfo.currency_name
            }</strong></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>SPOT:</td>
            <td style='text-align-last: right;'><strong><span class="text--active">
                ${format(",.6r")(this.spot)}
                </span></strong></td>
          </tr>
          <tr>
            <td>Updated at:</td>
            <td>
              <span class="text--active">
                ${this.updatedDate}
              </span>
             </td>
          </tr>
        </tbody>
      </table>`;
    }
  },

  methods: {
    // User interactions
    onHoverLeftSidebar(val) {
      Object.assign(this.userInteractions, { hoverVariable: val });
    },
    onHoverLeftSidebarSubItem(val) {
      this.userInteractions.hoverVariableSubItem = val;
    },
    onUserClickLeftSidebarShow() {
      this.$emit("eventOnUserClickLeftSidebarShow", !this.visibleLeft);
    },
    onLeftSidebarAnalysisScenarios() {
      Object.assign(this.userInteractions, { hoverVariable: "" });
    },
    onLeftSidebarAnalysis({ val, parent }) {
      this.$emit("eventOnLeftSidebarAnalysis", { val, parent });
    },
    onUserCurrencySelection({ item, nameEvent }) {
      if (nameEvent === "onUserCurrencySelection" && !item.children) {
        this.$emit("onUserCurrencySelection", { item, nameEvent });
      }
    },
    onUserChangeAnalysis({ item, nameEvent }) {
      if (nameEvent === "onUserChangeAnalysis" && !item.children) {
        this.$emit("onUserChangeAnalysis", { item, nameEvent });
      }
    },
    // Configuration data
    setDisabledElement(text, setVariable) {
      this.sidebarData.items.forEach((parentItem, i) => {
        if (parentItem.text === text) {
          this.$set(this.sidebarData.items, i, {
            ...parentItem,
            isDisabled: this[setVariable]
          });
        }
      });
    },
    setNewSpot() {
      this.sidebarData.items.forEach(parentItem => {
        if (parentItem.text === "Currency Information") {
          Object.assign(parentItem, { dataInfo: this.dataInfo });
        }
      });
    },
    setItemsSideBar() {
      this.$set(this, "sidebarData", {
        items: [
          {
            action: "template",
            bdr: false,
            bdrTransition: false,
            classNameIcon: "fa fa-question-circle",
            dataInfo: this.dataInfo,
            isOpen: false,
            itemHeader: false,
            nameEvent: "infoCurr",
            text: "Currency Information"
          },
          {
            bdr: false,
            bdrTransition: false,
            children: this.currencySpecs,
            childSelected: this.activeElements.currency,
            classNameIcon: null,
            filteredChildren: this.currencySpecs,
            icon: "CurrencyIcon",
            isDisabled: this.showLoading,
            isFiltered: true,
            isOpen: false,
            itemHeader: false,
            nameData: "currency_name",
            nameEvent: "onUserCurrencySelection",
            text: "Currencies"
          },
          {
            bdr: false,
            bdrTransition: false,
            children: this.listAnalysis,
            childSelected: `${this.activeElements.analysis
              .slice(0, 1)
              .toUpperCase()}${this.activeElements.analysis
              .slice(1)
              .toLowerCase()}`,
            classNameIcon: null,
            icon: "AnalysisIcon",
            isOpen: false,
            itemHeader: false,
            nameData: "name",
            nameEvent: "onUserChangeAnalysis",
            text: "Analysis"
          }
        ]
      });
    }
  }
};
</script>
